import { jsx as p } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import s from "./styles.module.less.js";
const i = a((r, t) => {
  var o;
  return /* @__PURE__ */ p("div", { ref: t, ...r.props, className: `${s.inputSeparator} ${(o = r.props) == null ? void 0 : o.className}` });
});
export {
  i as InputSeparator
};
